// Externe Bibliotheken
import React from 'react';

// Interne Module
import { tripStartCountdown } from '@/_helper/bookingDetailsHelper';

export const countdownContainer = (finishDate) => {
    if (finishDate) {
        const countdown = tripStartCountdown(finishDate);
        if (countdown) {
            return (
                <div className="countdown">
                    Reisebeginn in <span>{countdown}</span> Tagen
                </div>
            );
        }
    }
};
